/* AURORA — premium interactions (vanilla, no deps) */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Scroll reveal ---- */
  function initReveals(root) {
    var scope = root || document;
    // Apply the theme's default reveal style to any element that left it blank.
    var dflt = document.documentElement.dataset.revealStyle || 'fade-up-blur';
    scope.querySelectorAll('[data-reveal=""]').forEach(function (el) { el.setAttribute('data-reveal', dflt); });
    var els = scope.querySelectorAll('[data-reveal]:not(.is-in)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- Count-up for stat blocks ---- */
  function animateCount(el) {
    var target = parseFloat(el.getAttribute('data-count'));
    var decimals = (el.getAttribute('data-decimals') | 0);
    var prefix = el.getAttribute('data-prefix') || '';
    var suffix = el.getAttribute('data-suffix') || '';
    if (isNaN(target) || reduce) {
      el.textContent = prefix + target.toFixed(decimals) + suffix;
      return;
    }
    var dur = 1400, start = null;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = prefix + (target * eased).toFixed(decimals) + suffix;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  function initCounters(root) {
    var els = (root || document).querySelectorAll('[data-count]:not(.counted)');
    if (!els.length || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('counted'); animateCount(el); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('counted'); animateCount(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.5 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- Tab switchers (feature-tabs) ---- */
  function initTabs(root) {
    (root || document).querySelectorAll('[data-tabs]').forEach(function (group) {
      var tabs = group.querySelectorAll('[data-tab]');
      var panels = group.querySelectorAll('[data-panel]');
      function activate(id) {
        tabs.forEach(function (t) { t.setAttribute('aria-selected', t.getAttribute('data-tab') === id); });
        panels.forEach(function (p) { p.toggleAttribute('hidden', p.getAttribute('data-panel') !== id); });
      }
      tabs.forEach(function (t) {
        t.addEventListener('click', function () { activate(t.getAttribute('data-tab')); });
        t.addEventListener('keydown', function (ev) {
          var arr = Array.prototype.slice.call(tabs);
          var i = arr.indexOf(t);
          if (ev.key === 'ArrowRight') { ev.preventDefault(); arr[(i + 1) % arr.length].focus(); arr[(i + 1) % arr.length].click(); }
          if (ev.key === 'ArrowLeft') { ev.preventDefault(); arr[(i - 1 + arr.length) % arr.length].focus(); arr[(i - 1 + arr.length) % arr.length].click(); }
        });
      });
    });
  }

  /* ---- Review marquee: duplicate track for seamless loop ---- */
  function initMarquee(root) {
    (root || document).querySelectorAll('[data-marquee]:not(.marquee-ready)').forEach(function (m) {
      m.classList.add('marquee-ready');
      var track = m.querySelector('[data-marquee-track]');
      if (!track) return;
      var setup = function () {
        if (m.dataset.marqueeCloned) return;
        m.dataset.marqueeCloned = '1';
        var clone = track.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        m.appendChild(clone);
      };
      // Defer the DOM clone until the marquee is near the viewport, and pause
      // the CSS animation while it is off-screen so it costs nothing when unseen.
      if (!('IntersectionObserver' in window)) { setup(); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { setup(); m.style.removeProperty('animation-play-state'); m.querySelectorAll('[data-marquee-track]').forEach(function (t) { t.style.removeProperty('animation-play-state'); }); }
          else { m.querySelectorAll('[data-marquee-track]').forEach(function (t) { t.style.animationPlayState = 'paused'; }); }
        });
      }, { rootMargin: '200px 0px' });
      io.observe(m);
    });
  }

  /* ---- Sticky add-to-cart reveal (product) ---- */
  function initStickyAtc(root) {
    var bar = (root || document).querySelector('[data-sticky-atc]');
    var anchor = (root || document).querySelector('[data-atc-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { threshold: 0 });
    io.observe(anchor);
  }

  /* ---- Scroll-linked motion: parallax + damped pinned story ---- */
  var sfxItems = [], sfxStories = [], sfxRAF = 0, sfxBound = false, sfxLast = 0;
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function smoothstep(e0, e1, x) { x = clamp((x - e0) / (e1 - e0), 0, 1); return x * x * (3 - 2 * x); }
  function collectScrollFX(root) {
    (root || document).querySelectorAll('[data-parallax]:not(.sfx-ready)').forEach(function (el) {
      el.classList.add('sfx-ready'); sfxItems.push(el);
    });
    (root || document).querySelectorAll('[data-scroll-story]:not(.sfx-ready)').forEach(function (el) {
      el.classList.add('sfx-ready');
      var stars = el.querySelector('[data-stars]');
      if (stars && !stars.children.length) {
        var out = '';
        for (var k = 0; k < 46; k++) {
          out += '<i style="left:' + (Math.random() * 100).toFixed(1) + '%;top:' + (Math.random() * 52).toFixed(1) + '%;width:' + (Math.random() * 1.3 + 0.6).toFixed(2) + 'px;height:' + (Math.random() * 1.3 + 0.6).toFixed(2) + 'px;animation-delay:' + (Math.random() * 3.2).toFixed(2) + 's"></i>';
        }
        stars.innerHTML = out;
      }
      sfxStories.push({
        el: el, cur: 0, target: 0,
        steps: el.querySelectorAll('[data-story-step]'),
        bars: el.querySelectorAll('[data-story-bar]'),
        chapter: el.querySelector('[data-story-chapter]')
      });
    });
  }
  function applyStory(st, p) {
    var n = st.steps.length || 1;
    st.el.style.setProperty('--story-progress', smoothstep(0.02, 0.98, p).toFixed(4));
    var idx = Math.min(n - 1, Math.floor(p * n));
    st.steps.forEach(function (step, i) { step.classList.toggle('is-active', i === idx); });
    st.bars.forEach(function (bar, i) { var seg = 1 / n; bar.style.setProperty('--p', (clamp((p - i * seg) / seg, 0, 1) * 100).toFixed(1) + '%'); });
    if (st.chapter) st.chapter.textContent = '0' + (idx + 1) + ' / 0' + n;
    st.el.setAttribute('data-active-step', idx);
  }
  function sfxFrame() {
    var vh = window.innerHeight, now = (window.performance ? performance.now() : Date.now()), moving = false, i;
    for (i = 0; i < sfxItems.length; i++) {
      var el = sfxItems[i], r = el.getBoundingClientRect();
      if (r.bottom < -vh || r.top > vh * 2) continue; // skip off-screen parallax
      var speed = parseFloat(el.getAttribute('data-parallax')) || 0.15;
      el.style.transform = 'translate3d(0,' + (-(r.top + r.height / 2 - vh / 2) * speed).toFixed(2) + 'px,0)';
    }
    for (i = 0; i < sfxStories.length; i++) {
      var st = sfxStories[i], r2 = st.el.getBoundingClientRect(), total = st.el.offsetHeight - vh;
      var near = r2.bottom > -vh * 0.5 && r2.top < vh * 1.5;
      st.el.classList.toggle('is-animating', near);
      if (!near) { continue; } // don't churn the scene while it's nowhere near view
      if (total > 0) st.target = clamp(-r2.top / total, 0, 1);
      st.cur += (st.target - st.cur) * 0.085;
      if (Math.abs(st.target - st.cur) > 0.0004) moving = true; else st.cur = st.target;
      applyStory(st, st.cur);
    }
    if (moving || now - sfxLast < 140) { sfxRAF = requestAnimationFrame(sfxFrame); } else { sfxRAF = 0; }
  }
  function sfxWake() { sfxLast = (window.performance ? performance.now() : Date.now()); if (!sfxRAF) sfxRAF = requestAnimationFrame(sfxFrame); }
  function initScrollFX(root) {
    if (reduce) return;
    collectScrollFX(root);
    if (!sfxBound) {
      window.addEventListener('scroll', sfxWake, { passive: true });
      window.addEventListener('resize', sfxWake);
      sfxBound = true;
    }
    if (sfxItems.length || sfxStories.length) sfxWake();
  }

  function boot(root) {
    initReveals(root); initCounters(root); initTabs(root); initMarquee(root); initStickyAtc(root); initScrollFX(root);
  }

  if (document.readyState !== 'loading') boot(document);
  else document.addEventListener('DOMContentLoaded', function () { boot(document); });

  /* Re-init inside Shopify theme editor when a section is added/loaded */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:select', function (e) { initReveals(e.target); });

  window.Aurora = { boot: boot };
})();
